import type { DescriptionTemplateReplacementsInner } from './DescriptionTemplateReplacementsInner'
import {
  DescriptionTemplateReplacementsInnerFromJSON,
  DescriptionTemplateReplacementsInnerToJSON
} from './DescriptionTemplateReplacementsInner'

/**
 *
 * @export
 * @interface DescriptionTemplate
 */
export interface DescriptionTemplate {
  /**
   * Localized description template of the finding
   * @type {string}
   * @memberof DescriptionTemplate
   */
  template: string
  /**
   * Metadata about the placeholders in the template
   * @type {Array<DescriptionTemplateReplacementsInner>}
   * @memberof DescriptionTemplate
   */
  replacements: DescriptionTemplateReplacementsInner[]
}

/**
 * Check if a given object implements the DescriptionTemplate interface.
 */
export function instanceOfDescriptionTemplate(value: object): boolean {
  if (!('template' in value)) {return false}
  if (!('replacements' in value)) {return false}
  return true
}

export function DescriptionTemplateFromJSON(json: any): DescriptionTemplate {
  return DescriptionTemplateFromJSONTyped(json, false)
}

export function DescriptionTemplateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DescriptionTemplate {
  if (json == null) {
    return json
  }
  return {
    template: json.template,
    replacements: (json.replacements as any[]).map(
      DescriptionTemplateReplacementsInnerFromJSON
    )
  }
}

export function DescriptionTemplateToJSON(
  value?: DescriptionTemplate | null
): any {
  if (value == null) {
    return value
  }
  return {
    template: value.template,
    replacements: (value.replacements as any[]).map(
      DescriptionTemplateReplacementsInnerToJSON
    )
  }
}
